// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App'; // Ensure this imports './App'

ReactDOM.render(<App />, document.getElementById('root'));
